<vd-layout #layout>
	<vd-navigation-drawer color="primary" name="{{user?.displayName}}" email="{{user?.email}}" flex>
		<!-- #region Main menu -->
		<mat-nav-list>
			<ng-template let-item let-last="last" ngFor [ngForOf]="menu">
				<vd-menu [items]="item.items" [activeExact]="false" (click)="layout.close()"></vd-menu>
			</ng-template>
		</mat-nav-list>
		<!-- #endregion -->

		<!-- #region User menu -->
		<vd-menu [items]="userMenu" [activeExact]="false" (click)="layout.close()" vd-navigation-drawer-menu></vd-menu>
		<!-- #endregion -->
	</vd-navigation-drawer>

	<!-- #region Copyright footer -->
	<div vd-sidenav-content class="vd-layout-footer pad">{{copyright}}</div>
	<!-- #endregion -->

	<!-- #region Loading indicator -->
	<app-loading-screen></app-loading-screen>
	<div *ngIf="!loaded" layout="column" layout-fill>
		<div layout="column" layout-align="center center" flex>
			<mat-spinner></mat-spinner>
			<div class="md-title pad-top">Loading...</div>
		</div>
	</div>
	<!-- #endregion -->

	<!-- #region Main Content -->
	<router-outlet></router-outlet>
	<!-- #endregion -->
</vd-layout>